var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooterLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 21,
    viewBox: "0 0 82 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.4542 5.34473H78.2824V7.17189H76.4542V5.34473Z",
    fill: "url(#paint0_linear_1908_32943)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.626 3.51758H76.4542V5.34473L74.626 5.34474V3.51758Z",
    fill: "url(#paint1_linear_1908_32943)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.626 7.17189L76.4542 7.17189V8.99905H74.626V7.17189Z",
    fill: "url(#paint2_linear_1908_32943)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7978 5.34473L74.626 5.34474V7.17189L72.7978 7.17189V5.34473Z",
    fill: "url(#paint3_linear_1908_32943)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.44068 5.12723C7.90712 5.22873 9.14034 6.251 9.14034 8.19403C9.14034 10.6156 7.55166 11.8263 4.3743 11.8263H3.48203V10.1516H4.52664C5.49871 10.1516 6.17336 10.0066 6.55058 9.71656C6.9278 9.41205 7.11641 8.9118 7.11641 8.21578C7.11641 7.76628 6.94956 7.43277 6.61586 7.21527C6.28217 6.98326 5.85417 6.86726 5.33186 6.86726C4.30176 6.86726 3.48929 7.22977 2.89444 7.95478C2.3141 8.67979 2.02393 9.54981 2.02393 10.5648C2.02393 11.6378 2.33586 12.5079 2.95973 13.1749C3.5981 13.8419 4.42508 14.1754 5.44068 14.1754C6.35471 14.1754 7.1019 13.9506 7.68224 13.5011L8.988 14.7844C7.98691 15.5964 6.80447 16.0024 5.44068 16.0024C3.78671 16.0024 2.46644 15.5167 1.47986 14.5451C0.493288 13.5736 0 12.3194 0 10.7823C0 9.0713 0.486034 7.68652 1.4581 6.62801C2.43017 5.56949 3.75769 5.06923 5.44068 5.12723Z",
    fill: "url(#paint4_linear_1908_32943)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6513 10.5648V20.744H19.6927V10.5648C19.6927 8.15778 18.5683 6.95426 16.3195 6.95426C15.7972 6.95426 15.3257 7.04851 14.9049 7.23702C14.4987 7.41102 14.1505 7.65752 13.8603 7.97653C13.5701 8.29554 13.3452 8.67979 13.1857 9.1293C13.0261 9.56431 12.9463 10.0428 12.9463 10.5648C12.9463 11.0868 13.0261 11.5726 13.1857 12.0221C13.3452 12.4571 13.5701 12.8341 13.8603 13.1531C14.1505 13.4721 14.4987 13.7259 14.9049 13.9144C15.3257 14.0884 15.7972 14.1754 16.3195 14.1754C17.277 14.1754 18.1185 13.9144 18.844 13.3924V15.3499C18.0605 15.7849 17.219 16.0024 16.3195 16.0024C15.5505 16.0024 14.8396 15.8647 14.1867 15.5892C13.5484 15.2992 12.9898 14.9076 12.511 14.4146C12.0322 13.9216 11.655 13.3489 11.3793 12.6964C11.1182 12.0293 10.9876 11.3188 10.9876 10.5648C10.9876 9.81081 11.1254 9.1003 11.4011 8.43329C11.6768 7.76628 12.054 7.19352 12.5328 6.71501C13.0115 6.222 13.5774 5.83774 14.2303 5.56224C14.8831 5.27223 15.5795 5.12723 16.3195 5.12723C17.1029 5.12723 17.8211 5.24323 18.474 5.47524C19.1269 5.69274 19.6854 6.0335 20.1497 6.4975C20.6285 6.94701 20.9985 7.51252 21.2596 8.19403C21.5208 8.87554 21.6513 9.66581 21.6513 10.5648Z",
    fill: "url(#paint5_linear_1908_32943)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6209 15.7849H28.856C27.2456 15.7849 26.0921 15.5457 25.3957 15.0672C24.7719 14.6466 24.3729 14.1464 24.1988 13.5664C24.0392 12.9719 23.9594 12.1961 23.9594 11.2391V5.34474H25.8745V11.2173C25.8745 11.4783 25.8818 11.7031 25.8963 11.8916C25.9108 12.0656 25.9616 12.2976 26.0486 12.5876C26.1357 12.8631 26.259 13.0951 26.4186 13.2836C26.5782 13.4576 26.8103 13.6171 27.115 13.7621C27.4197 13.8926 27.7896 13.9579 28.2249 13.9579H30.7058V5.34474H32.6209V15.7849Z",
    fill: "url(#paint6_linear_1908_32943)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3508 20.744V10.5648C35.3508 9.81081 35.4886 9.1003 35.7643 8.43329C36.04 7.76628 36.4172 7.19352 36.896 6.71501C37.3747 6.222 37.9406 5.83774 38.5934 5.56224C39.2463 5.27223 39.9427 5.12723 40.6827 5.12723C41.4226 5.12723 42.1118 5.27223 42.7501 5.56224C43.403 5.83774 43.9688 6.222 44.4476 6.71501C44.9409 7.20802 45.3254 7.78803 45.601 8.45504C45.8767 9.10755 46.0145 9.81081 46.0145 10.5648C46.0145 11.3188 45.8767 12.0293 45.601 12.6964C45.3399 13.3489 44.9699 13.9216 44.4911 14.4146C44.0124 14.9076 43.4465 15.2992 42.7936 15.5892C42.1408 15.8647 41.4371 16.0024 40.6827 16.0024C39.7541 16.0024 38.8909 15.7849 38.0929 15.3499V13.3924C38.8038 13.9144 39.6453 14.1754 40.6174 14.1754C41.1397 14.1754 41.6112 14.0884 42.0319 13.9144C42.4672 13.7259 42.8299 13.4721 43.1201 13.1531C43.4248 12.8341 43.6569 12.4571 43.8165 12.0221C43.9761 11.5726 44.0559 11.0868 44.0559 10.5648C44.0559 10.0428 43.9761 9.56431 43.8165 9.1293C43.6569 8.67979 43.432 8.29554 43.1419 7.97653C42.8517 7.65752 42.4962 7.41102 42.0755 7.23702C41.6692 7.04851 41.205 6.95426 40.6827 6.95426C40.1749 6.95426 39.7106 7.04126 39.2899 7.21527C38.8836 7.38927 38.5282 7.63577 38.2235 7.95478C37.9333 8.27378 37.7084 8.65804 37.5488 9.10755C37.3892 9.54256 37.3094 10.0283 37.3094 10.5648V20.744H35.3508Z",
    fill: "url(#paint7_linear_1908_32943)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2937 11.6523V0.559654H50.2523V11.6523C50.2523 12.1743 50.3103 12.6021 50.4264 12.9356C50.557 13.2546 50.7528 13.4866 51.014 13.6316C51.2752 13.7621 51.529 13.8491 51.7757 13.8926C52.0223 13.9361 52.3488 13.9579 52.755 13.9579V15.7849C51.1301 15.7849 49.9766 15.4732 49.2947 14.8496C48.6274 14.2261 48.2937 13.1604 48.2937 11.6523Z",
    fill: "url(#paint8_linear_1908_32943)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8209 15.7849H59.056C57.4456 15.7849 56.2921 15.5457 55.5957 15.0672C54.9719 14.6466 54.5729 14.1464 54.3988 13.5664C54.2392 12.9719 54.1594 12.1961 54.1594 11.2391V5.34474H56.0745V11.2173C56.0745 11.4783 56.0818 11.7031 56.0963 11.8916C56.1108 12.0656 56.1616 12.2976 56.2486 12.5876C56.3357 12.8631 56.459 13.0951 56.6186 13.2836C56.7782 13.4576 57.0103 13.6171 57.315 13.7621C57.6197 13.8926 57.9896 13.9579 58.4249 13.9579H60.9058V5.34474H62.8209V15.7849Z",
    fill: "url(#paint9_linear_1908_32943)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7978 5.34473V7.17189L68.9458 7.17177C68.525 7.17177 68.1623 7.25152 67.8577 7.41102C67.553 7.57052 67.4006 7.79528 67.4006 8.08528C67.4006 8.25928 67.4369 8.41879 67.5095 8.56379C67.582 8.69429 67.6618 8.80304 67.7488 8.89005C67.8504 8.97705 67.9955 9.0713 68.1841 9.1728C68.3872 9.2598 68.5396 9.32505 68.6411 9.36855C68.7572 9.39755 69.2215 9.54256 70.0339 9.80356C70.8464 10.0646 71.4485 10.2821 71.8402 10.4561C72.232 10.6301 72.5294 10.8693 72.7325 11.1738C72.9501 11.4638 73.088 11.7538 73.146 12.0438C73.204 12.3194 73.233 12.5949 73.233 12.8704C73.233 14.8134 71.8983 15.7849 69.2287 15.7849H65.4638V13.9579H69.2287C70.5925 13.9579 71.2744 13.5954 71.2744 12.8704C71.2744 12.5224 71.0713 12.2324 70.665 12.0003C70.2733 11.7683 69.7873 11.5726 69.2069 11.4131C68.6411 11.2536 68.068 11.0723 67.4877 10.8693C66.9219 10.6518 66.4358 10.3111 66.0296 9.84706C65.6379 9.36855 65.442 8.78129 65.442 8.08528C65.442 7.20077 65.7829 6.5265 66.4648 6.0625C67.1467 5.58399 67.9737 5.34474 68.9458 5.34474L72.7978 5.34473Z",
    fill: "url(#paint10_linear_1908_32943)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6274 8.74855H76.4556V10.5757L74.6274 10.5757V8.74855Z",
    fill: "url(#paint11_linear_1908_32943)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6274 1.82716H76.4556V3.65432L74.6274 3.65432V1.82716Z",
    fill: "url(#paint12_linear_1908_32943)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6274 0H76.4556V1.82716H74.6274V0Z",
    fill: "url(#paint13_linear_1908_32943)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1106 5.34493H81.9388V7.17208L80.1106 7.17209V5.34493Z",
    fill: "url(#paint14_linear_1908_32943)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6274 10.5757L76.4556 10.5757V12.4029L74.6274 12.4029V10.5757Z",
    fill: "url(#paint15_linear_1908_32943)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2824 5.34473L80.1106 5.34493V7.17209L78.2824 7.17189V5.34473Z",
    fill: "url(#paint16_linear_1908_32943)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1908_32943",
    x1: 0,
    y1: 10.372,
    x2: 81.9388,
    y2: 10.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C1FE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A06B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1908_32943",
    x1: 0,
    y1: 10.372,
    x2: 81.9388,
    y2: 10.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C1FE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A06B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1908_32943",
    x1: 0,
    y1: 10.372,
    x2: 81.9388,
    y2: 10.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C1FE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A06B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1908_32943",
    x1: 0,
    y1: 10.372,
    x2: 81.9388,
    y2: 10.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C1FE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A06B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1908_32943",
    x1: 0,
    y1: 10.372,
    x2: 81.9388,
    y2: 10.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C1FE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A06B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1908_32943",
    x1: 0,
    y1: 10.372,
    x2: 81.9388,
    y2: 10.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C1FE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A06B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1908_32943",
    x1: 0,
    y1: 10.372,
    x2: 81.9388,
    y2: 10.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C1FE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A06B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1908_32943",
    x1: 0,
    y1: 10.372,
    x2: 81.9388,
    y2: 10.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C1FE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A06B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1908_32943",
    x1: 0,
    y1: 10.372,
    x2: 81.9388,
    y2: 10.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C1FE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A06B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1908_32943",
    x1: 0,
    y1: 10.372,
    x2: 81.9388,
    y2: 10.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C1FE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A06B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1908_32943",
    x1: 0,
    y1: 10.372,
    x2: 81.9388,
    y2: 10.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C1FE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A06B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1908_32943",
    x1: 0,
    y1: 10.372,
    x2: 81.9388,
    y2: 10.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C1FE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A06B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1908_32943",
    x1: 0,
    y1: 10.372,
    x2: 81.9388,
    y2: 10.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C1FE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A06B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1908_32943",
    x1: 0,
    y1: 10.372,
    x2: 81.9388,
    y2: 10.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C1FE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A06B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1908_32943",
    x1: 0,
    y1: 10.372,
    x2: 81.9388,
    y2: 10.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C1FE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A06B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1908_32943",
    x1: 0,
    y1: 10.372,
    x2: 81.9388,
    y2: 10.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C1FE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A06B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1908_32943",
    x1: 0,
    y1: 10.372,
    x2: 81.9388,
    y2: 10.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C1FE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A06B8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLogo);
export default __webpack_public_path__ + "static/media/footer-logo.1be0f7d413391b610affd55591754b59.svg";
export { ForwardRef as ReactComponent };